module.exports = __webpack_public_path__ + "img/flower.f6259678.png";